import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.mrtradeweb.com",
  withCredentials: true,
});

instance.interceptors.request.use(
  config => {
    if (window.__RATE_BANNED__) {
      return Promise.reject({
        isRateBanned: true,
        message: "Запросы заблокированы из-за превышения лимита.",
        banSecondsLeft: window.__BAN_SECONDS_LEFT__ || 300,
      });
    }
    return config;
  },
  error => Promise.reject(error)
);

instance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 429) {
      window.__RATE_BANNED__ = true;
      window.__BAN_SECONDS_LEFT__ = error.response?.data?.seconds_left || 300;
      window.location.reload();
      return;
    }

    if (originalRequest && originalRequest._retry) {
      alert("Сессия истекла. Пожалуйста, перезапустите приложение.");
      if (window.Telegram?.WebApp?.close) {
        window.Telegram.WebApp.close();
      } else {
        window.location.href = "/";
      }
      return Promise.reject(error);
    }

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/refresh-token")
    ) {
      originalRequest._retry = true;
      try {
        await instance.post("/refresh-token/");
        return instance(originalRequest);
      } catch (refreshError) {
        alert("Сессия истекла. Пожалуйста, перезапустите приложение.");
        if (window.Telegram?.WebApp?.close) {
          window.Telegram.WebApp.close();
        } else {
          window.location.href = "/";
        }
        return Promise.reject(refreshError);
      }
    }

    if (
      (!error.response && !originalRequest._retried) ||
      (error.code === "ECONNABORTED" && !originalRequest._retried)
    ) {
      originalRequest._retried = (originalRequest._retried || 0) + 1;
      if (originalRequest._retried <= 2) {
        await new Promise(res => setTimeout(res, 1000));
        return instance(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;















